import { useState, useEffect, useRef } from "react";

function Fulfillment({ lineItem }) {
  if (!lineItem.fulfillment) { return null }

  if (lineItem.fulfillment.tracking_url) {
    return (
      <a href={lineItem.fulfillment.tracking_url} className="flex items-center">
        <span className="text-sm underline uppercase underline-offset-4">Track Shipment</span>
        <svg aria-hidden="true" aria-focusable="false" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.9764 10.5829L6.85156 6.45811L8.03008 5.2796L13.3334 10.5829L8.03008 15.8862L6.85156 14.7077L10.9764 10.5829Z" fill="black"/>
        </svg>
      </a>  
    )
  } else {
    if (!lineItem.fulfillment.tracking_company || !lineItem.fulfillment.tracking_number) return null;

    return (
      <div className="text-sm uppercase">
        <span>Fulfilled: {lineItem.fulfillment.tracking_company} {lineItem.fulfillment.tracking_number}
        </span>
      </div>
    )
  }
}

function Status({ lineItemStatus, statusFlow, isLastUpdateAnAlert }) {
  // If the last update type is "alert", display "On Hold"
  if (isLastUpdateAnAlert) return "On Hold";

  // If there is no status, display the first status in the flow
  if (!lineItemStatus?.status) return statusFlow[0];

  // If the status is "Shipped", display it as "Arriving Soon"
  if (lineItemStatus.status === "Shipped") return "Arriving Soon";

  // Else display as is
  return lineItemStatus.status;
}

export function OrderProgressBar({ lineItem, lineItemStatus, statusFlow, isLastUpdateAnAlert }) {
  const [progressBarPc, setProgressBarPc] = useState("0%");
  const progressBar = useRef(null);
  const activeStatusEl = useRef(null);

  useEffect(() => {
    const indexOfCurrentStatus = lineItemStatus?.status ? statusFlow.findIndex((el: string) => el === lineItemStatus.status) : 0;

    let pc = ((indexOfCurrentStatus + 0.5) / statusFlow.length) * 100;
    if (indexOfCurrentStatus === statusFlow.length - 1) {
      pc = 100;
    }

    setProgressBarPc(`${pc}%`);

    // Scroll to active status
    activeStatusEl.current?.scrollIntoView({behavior: 'instant', inline: 'center', block: 'nearest'});
  }, []);

  return (
    <div>
      <div className="flex justify-between items-center mb-[1.25rem] mt-[2rem] lg:mt-0">
        <p className="text-[2rem] md:text-[2.25rem] leading-6">
          <span className="sr-only">Status: </span>
          <Status lineItemStatus={lineItemStatus} statusFlow={statusFlow} isLastUpdateAnAlert={isLastUpdateAnAlert} />
        </p>
          
        <Fulfillment lineItem={lineItem} />
      </div>

      <div className="w-full overflow-hidden"> 
        <div ref={progressBar} className="w-full overflow-x-scroll overflow-y-hidden scrollbar-none">
            <div style={{ minWidth: statusFlow.length * 11 + "rem" }}>
              <div aria-hidden="true" className="mb-[1.5rem] md:mb-[2rem]">
                <div className="bg-[#D7D1CC] w-full h-[10px] rounded-[6px]">
                <div className={`${isLastUpdateAnAlert ? `bg-[#E10000]` : `bg-[#3FB472]`} w-[0px] h-[10px] rounded-[8px]`} style={{ width: progressBarPc, transition: 'width 1s ease-in-out' }}></div>
                </div>
                <div className={`grid grid-cols-${statusFlow.length} mt-2 gap-x-2`}>
                  {statusFlow.map((status) => {
                    const isActive = status === lineItemStatus?.status;
                    const itemProps = isActive ? { ref: activeStatusEl } : {};

                    return (
                      <p
                        className={`text-[0.875rem] text-center first:text-left last:text-right ${isActive ? 'text-black' : 'text-[#A5A09B]'}`}
                        {...itemProps}
                      >
                        {status}
                      </p>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}